<div class="mi-home-header">
    <header class="mc-pt-16">
        <div class="d-flex justify-content-center justify-content-md-start mc-mb-4  mc-mb-md-2">
            <img src="assets/images/general/comingSoonPage.svg" [alt]="'gov il'">
        </div>
    </header>
</div>